module.exports = __webpack_public_path__ + "img/project-disaster-escape-plan-3.c15c317a.png";